import { render, staticRenderFns } from "./AlarmDetails.vue?vue&type=template&id=662a2ec2&scoped=true&"
import script from "./AlarmDetails.vue?vue&type=script&lang=ts&"
export * from "./AlarmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmDetails.vue?vue&type=style&index=0&id=662a2ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a2ec2",
  null
  
)

component.options.__file = "AlarmDetails.vue"
export default component.exports